import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { RecordAttributes, RecordData } from 'webapp-types';
import { omit } from 'webapp/utils/common';

import ApplicationSerializer from 'webapp/serializers/application';

import type BoardLoopRecord from 'webapp/models/board-loop';

export default class BoardLoopSerializer extends ApplicationSerializer {
	override getReadOnlyFields(_json: Record<string, unknown>): RecordData.BoardLoop.ReadOnlyKey[] {
		return ['created', 'createdBy'];
	}

	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a record through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.BoardLoop.Raw | RecordData.BoardLoop.Serialized,
		prop: string | undefined,
	) {
		const { settings, ...data } = json;
		const attributes: Partial<RecordAttributes<BoardLoopRecord>> & { id?: string | number } = {
			...data,
		};

		if (settings) {
			if (typeof settings.loopDelay !== 'undefined') {
				attributes.loopDelay = settings.loopDelay;
			}
			if (typeof settings.restrictIps !== 'undefined') {
				attributes.restrictIps = settings.restrictIps;
			}
			if (typeof settings.password !== 'undefined') {
				attributes.password = settings.password;
			}
		}

		return super.normalize(typeClass, attributes, prop);
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.BoardLoop.Serialized {
		// read-only fields are already removed by ApplicationSerializer
		const attributes = super.serialize(snapshot, options) as Omit<
			RecordAttributes<BoardLoopRecord>,
			RecordData.BoardLoop.ReadOnlyKey
		>;

		return {
			...omit(attributes, 'loopDelay', 'restrictIps', 'password', 'newBadge'),
			settings: {
				loopDelay: attributes.loopDelay || 0,
				restrictIps: attributes.restrictIps || [],
				password: attributes.password || '',
			},
		};
	}
}
